import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'

export type ButtonStylesParams = {
  buttonDefaultFont: StyleParamType.Font
  buttonDefaultColor: StyleParamType.Color
  buttonDefaultFillColor: StyleParamType.Color
  buttonDefaultBorderWidth: StyleParamType.Number
  buttonDefaultBorderColor: StyleParamType.Color
  buttonDefaultCornerRadiusTopLeft: StyleParamType.Number
  buttonDefaultCornerRadiusTopRight: StyleParamType.Number
  buttonDefaultCornerRadiusBottomLeft: StyleParamType.Number
  buttonDefaultCornerRadiusBottomRight: StyleParamType.Number

  buttonHoverFont: StyleParamType.Font
  buttonHoverColor: StyleParamType.Color
  buttonHoverFillColor: StyleParamType.Color
  buttonHoverBorderColor: StyleParamType.Color
}

export const buttonStylesParams = createStylesParams<ButtonStylesParams>({
  buttonDefaultFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
  },
  buttonDefaultColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  buttonDefaultFillColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
  },
  buttonDefaultBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  buttonDefaultBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.12),
  },
  buttonDefaultCornerRadiusTopLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  buttonDefaultCornerRadiusTopRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  buttonDefaultCornerRadiusBottomLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  buttonDefaultCornerRadiusBottomRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },

  buttonHoverFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      style: {bold: false, italic: false, underline: true},
    }),
  },
  buttonHoverColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  buttonHoverFillColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action', 1),
  },
  buttonHoverBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.12),
  },
})
